import { ANNOTATION_TYPE } from '@/shared/ui';

type AFibEventInstance = {
  type: string;
  canvasChart: HTMLCanvasElement;
  ctxChart: CanvasRenderingContext2D | null;
  config: any;
  displayedChannelsArr: number[];
  pixelSamples: any;
  channelIndex: number;
  startSample: number;
  endSample: number;
  color: string;
  drawOneAFibEvent: (offsetX: number, strokeStyle?: string) => void;
  update: (pixelSamples: any, config: any, displayedChannelsArr: number[]) => void;
  getJSONObject: () => {
    type: string;
    channelIndex: number;
    startSample: number;
    endSample: number;
  };
};
type AFibEventCtor = new (
  canvasChart: HTMLCanvasElement,
  config: any,
  displayedChannelsArr: number[],
  pixelSamples: any,
  afibEvent: { channelIndex: number; startSample: number; endSample: number },
) => AFibEventInstance;

let AFibEventImpl: any;

(function () {
  AFibEventImpl = function (
    canvasChart: HTMLCanvasElement,
    config: any,
    displayedChannelsArr: number[],
    pixelSamples: any,
    afibEvent: { channelIndex: number; startSample: number; endSample: number },
  ) {
    this.type = ANNOTATION_TYPE.AFIB_EVENT;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = afibEvent.channelIndex;
    this.startSample = afibEvent.startSample;
    this.endSample = afibEvent.endSample;
    this.color = 'red';
  };

  AFibEventImpl.prototype.drawOneAFibEvent = function (offsetX: number, strokeStyle = this.color) {
    this.ctxChart.beginPath();
    this.ctxChart.strokeWidth = 1.5;
    this.ctxChart.strokeStyle = strokeStyle;
    this.displayedChannelsArr.forEach((element: number, index: number) => {
      if (this.channelIndex === element) {
        for (let j = this.startSample; j < this.endSample; j += 1) {
          this.ctxChart.moveTo(
            this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j].y,
          );
          this.ctxChart.lineTo(
            this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j + 1].y,
          );
        }
      }
      this.ctxChart.stroke();
      this.ctxChart.closePath();
    });
  };

  AFibEventImpl.prototype.update = function (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: number[],
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
  };

  AFibEventImpl.prototype.getJSONObject = function () {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
    };
  };
})();

const AFibEvent: AFibEventCtor = AFibEventImpl;

export { AFibEvent };
export default { AFibEvent };
